import { render, staticRenderFns } from "./CompaniesUploaded.vue?vue&type=template&id=5e72098c&scoped=true&"
import script from "./CompaniesUploaded.vue?vue&type=script&lang=js&"
export * from "./CompaniesUploaded.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesUploaded.vue?vue&type=style&index=0&id=5e72098c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72098c",
  null
  
)

export default component.exports